<template>
    <div id="app">
        <nav class="navbar navbar-inverse navbar-fixed-top">
            <div class="container">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                    <a class="navbar-brand" href="#">42Data.co</a>
                </div>
                <div id="navbar" class="navbar-collapse collapse">
                    <ul class="nav navbar-nav">
                        <router-link tag="li" to="/" exact>
                            <a>Home</a>
                        </router-link>
                        <router-link tag="li" to="/contacto">
                            <a>Contacto</a>
                        </router-link>
                    </ul>
                </div>
            </div>
        </nav>

        <router-view></router-view>

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <hr>

                    <footer>
                        <p>© 42Data - All Rights Reserved</p>
                    </footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<script>
!function (t, e, n, s) {
    t.DPEventsFunction = s, t[s] = t[s] || function () {(t[s].q = t[s].q || []).push(arguments)};
    var c = e.createElement("script"), o = e.getElementsByTagName("script")[0]
    c.async = 1, c.src = n, o.parentNode.insertBefore(c, o)
}(window, document, "https://scout.masivapp.com/scout.js", "_scout");
_scout('configure', {s: 'MjU=', k: 'YVAwRGFzSlQ1TzFYMmpacGxJWmdiNEVKUFNOeHoxUEU0cXZMYXpMdQ=='});
_scout('visit', 10)
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
img {
  width: 250px;
  border-radius: 0px;
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.5);
  transition: width 1s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue